<template>
<div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="gb" :gotodownload="gotodownload" :apk="apk" />

  <div id="page" class="site container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area page-primary">
        <main id="maincontent" class="site-main page-main-narrow">
          <article class="home-article prose">
            <section class="home-hero-panel" aria-label="GB WhatsApp download hero">
              <h1>GB WhatsApp APK New Version Download v18.80 Updated 2026</h1>

              <div class="home-hero-icon-wrap">
                <div class="home-hero-icon-ring">
                  <img class="home-hero-icon" src="@/assets/gbwa-logo.webp" alt="GB WhatsApp" width="220" height="220" decoding="async">
                </div>
              </div>

              <div class="home-hero-cta-wrap">
                <router-link class="home-download-btn" to="/download/">
                  Download GB WhatsApp APK Now
                </router-link>
              </div>

              <div class="home-app-details-wrap">
                <h2 class="home-app-details-heading">GB WhatsApp App Details</h2>
                <div class="home-app-details-table-wrap">
                  <table class="home-app-details-table">
                    <tbody>
                      <tr v-for="item in appDetails" :key="item.label">
                        <th scope="row">{{ item.label }}</th>
                        <td>{{ item.value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </section>

            <h2>What Is GB WhatsApp?</h2>
            <p>
              <router-link to="/"><strong>GB WhatsApp</strong></router-link>
              is a modified version of the official WhatsApp Messenger application designed to provide enhanced features not available in the original app. It offers additional customization options, expanded privacy controls, and improved media sharing capabilities. Unlike the official WhatsApp version available on app stores,
              <router-link to="/"><strong>GBWhatsApp</strong></router-link>
              is distributed as an APK file and must be installed manually on Android devices.
            </p>
            <div class="home-image-carousel" aria-label="GB WhatsApp feature screenshots">
              <button class="home-carousel-arrow home-carousel-arrow-prev" type="button" aria-label="Previous screenshot" @click="prevIntroSlide">
                <span aria-hidden="true">&lsaquo;</span>
              </button>
              <div class="home-carousel-stage">
                <img
                  class="home-carousel-image"
                  :src="introImages[activeIntroSlide].src"
                  :alt="introImages[activeIntroSlide].alt"
                  loading="lazy"
                  decoding="async"
                >
              </div>
              <button class="home-carousel-arrow home-carousel-arrow-next" type="button" aria-label="Next screenshot" @click="nextIntroSlide">
                <span aria-hidden="true">&rsaquo;</span>
              </button>
              <div class="home-carousel-dots" aria-label="Choose screenshot">
                <button
                  v-for="(image, index) in introImages"
                  :key="image.src"
                  class="home-carousel-dot"
                  :class="{ active: activeIntroSlide === index }"
                  type="button"
                  :aria-label="`Show screenshot ${index + 1}`"
                  :aria-pressed="activeIntroSlide === index ? 'true' : 'false'"
                  @click="setIntroSlide(index)"
                ></button>
              </div>
            </div>

            <h2>Key Features of GB WhatsApp</h2>
            <p>
              GB WhatsApp is mainly popular because it gives users more control over <strong>privacy, appearance, and everyday messaging</strong>. Instead of changing just one part of WhatsApp, it adds extra settings that let you decide what other people can see and how the app looks and behaves.
            </p>

            <h3 class="home-features-subheading">More Control Over Your Privacy</h3>
            <p>
              One of the main reasons people choose GB WhatsApp is its additional privacy controls. The <strong>Ghost Mode-style settings</strong> let you hide activity indicators that normally tell other people what you are doing.
            </p>
            <p>
              Depending on the version, you can hide your online status, blue ticks, typing indicator, or recording status. Some builds also let you freeze Last Seen or apply different privacy settings to specific contacts.
            </p>
            <p>
              These options are useful when you want to read or reply to messages without constantly showing your activity to everyone.
            </p>

            <h3 class="home-features-subheading">Make WhatsApp Look the Way You Want</h3>
            <p>
              The standard WhatsApp interface gives you relatively limited customization. GB WhatsApp takes a different approach by giving you more control over the app's appearance.
            </p>
            <p>
              You can use custom <strong>themes, fonts, wallpapers, chat colors, message bubbles, and icons</strong> to create a look that feels more personal. If you like changing the appearance of your apps or simply don't like the default WhatsApp design, this is one of the more noticeable differences.
            </p>

            <h3 class="home-features-subheading">Other Useful Features in GB WhatsApp</h3>
            <p>
              Beyond privacy and customization, GB WhatsApp builds commonly include a collection of smaller tools that can make everyday use more flexible:
            </p>
            <ul class="home-features-list">
              <li><strong>App Lock</strong> - add a separate lock to protect access to your chats.</li>
              <li><strong>DND Mode</strong> - temporarily stop WhatsApp from connecting when you don't want interruptions.</li>
              <li><strong>Anti-Delete Options</strong> - view certain messages or statuses after they have been deleted, when supported.</li>
              <li><strong>Media Controls</strong> - get additional options for sending photos, videos, documents, and other files.</li>
              <li><strong>Call Privacy</strong> - access extra controls for incoming calls and selected contacts.</li>
              <li><strong>Chat Controls</strong> - use additional settings for individual conversations and notifications.</li>
            </ul>
            <p>
              The exact feature set can change between GB WhatsApp versions, so some options may not be available in every build.
            </p>

            <h2>How to Download and Install GB WhatsApp</h2>
            <p>
              GB WhatsApp is not available on the Google Play Store, so Android users need to download and install the APK manually.
            </p>
            <p><strong>Step-by-step guide:</strong></p>
            <ol class="home-steps-list">
              <li><strong>Check your device</strong> - Make sure your Android version meets the APK's minimum requirements and that you have enough storage.</li>
              <li><strong>Download the APK</strong> - Get the latest <strong>GB WhatsApp APK</strong> file from the download page.</li>
              <li><strong>Allow APK installation</strong> - If Android blocks the installation, allow your browser or file manager to install apps from that source.</li>
              <li><strong>Install GB WhatsApp</strong> - Open the downloaded APK and tap <strong>Install</strong>.</li>
              <li><strong>Verify your number</strong> - Launch the app and complete phone number verification.</li>
              <li><strong>Restore your chats</strong> - If a compatible backup is available, follow the restore options after verification.</li>
            </ol>
            <img class="home-wide-image" src="@/assets/content/Install-GBWhatsApp-Pro-APK-Latest-1536x1526.webp" alt="Install GB WhatsApp APK guide" loading="lazy" decoding="async">

            <h2>What's New in GB WhatsApp v18.80?</h2>
            <p>
              <router-link to="/"><strong>GB WhatsApp v18.80</strong></router-link>
              is the latest version listed on this site. This release focuses on keeping the app compatible with newer Android environments while improving stability and updating its existing features.
            </p>
            <p>
              If you are using an older version, check the version number and update information before switching. You can also keep an older build if it works better for your device and needs.
            </p>

            <h2>GB WhatsApp vs Official WhatsApp</h2>
            <p>
              If you are deciding between GBWhatsApp and the official WhatsApp app, the biggest difference is not just the number of features. It is the overall experience, support, privacy controls, and account risk.
            </p>
            <div class="home-compare-table-wrap">
              <table class="home-compare-table">
                <thead>
                  <tr>
                    <th scope="col">Category</th>
                    <th scope="col">GB WhatsApp</th>
                    <th scope="col">Official WhatsApp</th>
                    <th scope="col">What It Means for You</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Customization</th>
                    <td>More options</td>
                    <td>Standard</td>
                    <td>GB WhatsApp gives you more control over the look of the app</td>
                  </tr>
                  <tr>
                    <th scope="row">Privacy Controls</th>
                    <td>More granular</td>
                    <td>Standard</td>
                    <td>More options if you want to control what contacts can see</td>
                  </tr>
                  <tr>
                    <th scope="row">Security</th>
                    <td>Third-party</td>
                    <td>Official</td>
                    <td>Official WhatsApp provides a more established security model</td>
                  </tr>
                  <tr>
                    <th scope="row">Account Risk</th>
                    <td>Higher</td>
                    <td>Lower</td>
                    <td>GB WhatsApp carries additional account-related risk</td>
                  </tr>
                  <tr>
                    <th scope="row">Updates</th>
                    <td>Third-party</td>
                    <td>Official</td>
                    <td>Official WhatsApp provides more predictable updates</td>
                  </tr>
                  <tr>
                    <th scope="row">Support</th>
                    <td>Community / third-party</td>
                    <td>Official</td>
                    <td>Problems are easier to resolve with the official app</td>
                  </tr>
                  <tr>
                    <th scope="row">Chat Transfer</th>
                    <td>May vary</td>
                    <td>Fully supported</td>
                    <td>Switching to GB WhatsApp can require extra backup preparation</td>
                  </tr>
                  <tr>
                    <th scope="row">Best Choice For</th>
                    <td>Customization-focused users</td>
                    <td>Everyday users</td>
                    <td>Your priorities should determine which one you choose</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2>Is GB WhatsApp Safe to Use?</h2>
            <p>
              GB WhatsApp is a third-party modified app, so it does not have the same official security support as WhatsApp from Google Play. The main risks come from the APK source, privacy, and the fact that WhatsApp does not officially support modified clients.
            </p>
            <p>
              If you choose to use it, download the APK from a source you trust, scan the file before installing, and keep important chats backed up. <strong>GB WhatsApp offers more customization, but with less official security and support.</strong>
            </p>

            <h2>Can You Get Banned for Using GB WhatsApp?</h2>
            <p>
              Yes. Using an unofficial WhatsApp client can put your account at risk. WhatsApp may issue a <strong>temporary ban</strong>, which can require you to switch to the official app, or in more serious cases, a <strong>permanent ban</strong>.
            </p>
            <p>
              Some GBWhatsApp versions advertise an <strong>Anti-Ban</strong> feature, but it cannot guarantee that your account will never be restricted. If your account is important, consider this risk before switching.
            </p>

            <h2>System Requirements for GB WhatsApp</h2>
            <ul class="home-features-list">
              <li>Android 5.0 or higher</li>
              <li>Enough free storage for the APK and chat media</li>
              <li>Stable internet connection for verification and restore</li>
              <li>A working phone number that can receive SMS or calls</li>
            </ul>

            <h2>GB WhatsApp Old Version</h2>
            <p>
              Looking for an older GB WhatsApp version can make sense if the latest build has a compatibility problem or if you simply prefer an older interface.
            </p>
            <p>
              However, an old APK may miss newer features, security fixes, or compatibility improvements. Before installing one, check the <strong>version number, Android requirements, and APK source</strong> carefully.
            </p>
            <p>
              We recommend using an older version only when you have a specific reason to do so rather than assuming that an older build is automatically better. You can read our article:
              <a href="https://gbofficial.net/is-gb-whatsapp-old-version-worth-using/">Why People Still Use GB WhatsApp Old Versoin?</a>
            </p>

            <h2>How to Update GB WhatsApp Without Losing Chats</h2>
            <p>
              Back up your important chats before updating. If your current build supports normal updates, install the newer APK over the existing version instead of uninstalling first.
            </p>
            <p>
              After the update, open several chats and check your photos and videos before deleting any previous backup.
            </p>

            <h2>GB WhatsApp for PC/Web</h2>
            <p>
              GB WhatsApp is designed for Android, so there is no separate official <strong>GB WhatsApp for PC, Mac, or iPhone</strong> app.
            </p>
            <p>
              If you want to use your GB WhatsApp chats on a computer, you can try linking your account through WhatsApp Web or the official WhatsApp desktop app. However, some GB WhatsApp features may not work exactly the same way on a linked device.
            </p>
            <p>
              If you mainly use WhatsApp on a computer, the official WhatsApp app is the more straightforward option.
            </p>

            <h3 class="home-features-subheading">Who Should Use GB WhatsApp?</h3>
            <p>
              GB WhatsApp may be a good fit for Android users who want more control over <strong>privacy, customization, and everyday messaging</strong>. If you enjoy changing themes, hiding activity indicators, or using extra chat controls, a WhatsApp mod may offer more options than the standard app.
            </p>
            <p>
              However, it is not the best choice for everyone. If your main reason is <strong>automatic replies</strong>, for example, <a href="https://whatsappbusiness.com/">WhatsApp Business</a> may already provide what you need. Its business tools include automated messages such as greeting messages and away messages, without requiring a modified app.
            </p>
            <p>
              So the choice is fairly simple: <strong>choose GB WhatsApp for extra customization and privacy controls; choose WhatsApp Business if your priority is business messaging and auto-reply tools.</strong>
            </p>

            <h3 class="home-features-subheading">WhatsApp Mods Similar to GB WhatsApp</h3>
            <p>
              GB WhatsApp isn't the only modified version of WhatsApp. You may also come across names such as <strong>FMWhatsApp, WhatsApp Plus, YOWhatsApp, and OGWhatsApp</strong>.
            </p>
            <p>
              Most of these mods follow a similar idea: adding extra privacy, customization, or messaging features that aren't available in the standard app. The main differences are usually the interface, available features, and how actively each project is maintained.
            </p>
            <p>
              If you're comparing WhatsApp mods, don't choose based only on the number of features. Check the version, update history, compatibility, and download source as well.
            </p>

            <h3 class="home-features-subheading">Can I Switch Back to WhatsApp?</h3>
            <p>
              Yes. You can switch from GB WhatsApp back to the official WhatsApp app, but <strong>don't uninstall GB WhatsApp immediately if you need your existing chats</strong>.
            </p>
            <p>
              First, make sure your chats and media are backed up or otherwise safely preserved. Then install the official WhatsApp app, verify the same phone number, and follow the restore process if a compatible backup is available.
            </p>
            <p>
              Because GB WhatsApp is a modified app, its local or modified backup may not always restore directly into the official WhatsApp app. If your chats are important, check the backup situation before making the switch.
            </p>

            <h3 class="home-features-subheading">Why Can't I Download GB WhatsApp iOS Version?</h3>
            <p>
              There is no genuine <strong>GB WhatsApp APK for iPhone</strong> because APK is an Android package format. GB WhatsApp is primarily distributed as a modified Android app, so websites offering a simple "GB WhatsApp iOS APK" download are using misleading terminology.
            </p>
            <p>
              If you use an iPhone, you cannot simply download the Android GB WhatsApp APK and install it on iOS. Be especially careful with websites asking you to install unknown profiles, certificates, or configuration files while claiming to offer an official GB WhatsApp iOS version.
            </p>

            <h3 class="home-features-subheading">GBWhatsApp Ban Issues</h3>
            <p>
              Using GBWhatsApp comes with an account risk that you should understand before installing it. WhatsApp officially does not support modified apps such as GBWhatsApp, and its help center says that using an unofficial app may result in temporary or permanent account bans or other account restrictions.
            </p>
            <p>
              You may see a <strong>"Temporarily banned"</strong> message, or in more serious cases, a message saying that your phone number cannot use WhatsApp. WhatsApp also states that continuing to use an unofficial app after a temporary ban can lead to a permanent ban.
            </p>
            <p>
              For this reason, features sometimes described as <strong>"Anti-Ban" should not be treated as a guarantee</strong>. If your WhatsApp number is important for work, business, or daily communication, the official WhatsApp or WhatsApp Business app is the safer choice.
            </p>
            <p>
              If you already received a ban message, don't immediately keep switching between different GBWhatsApp builds. Check the message shown in WhatsApp and use the official <strong>Request Review</strong> option when it is available.
            </p>

            <h2>Frequently Asked Questions About GB WhatsApp</h2>
            <div class="home-faq-item" v-for="faq in faqs" :key="faq.q">
              <p class="home-faq-q">{{ faq.q }}</p>
              <p class="home-faq-a">{{ faq.a }}</p>
            </div>
          </article>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/page-narrow-layout.scss';
import HeadNav from '@/components/HeadNav.vue';
import 'swiper/css/swiper.css';

export default {
  name: 'Home',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'home',
      apk: null,
      lastupdate: null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
      appDetails: [
        { label: 'App Name', value: 'GB WhatsApp' },
        { label: 'Latest Version', value: 'V18.8' },
        { label: 'App Size', value: '80MB' },
        { label: 'Android Version', value: 'Android 6.0+' },
        { label: 'Root', value: 'No' },
        { label: 'Category', value: 'Mod APK' },
        { label: 'Last Updated', value: 'Sep, 2026' },
        { label: 'License', value: 'Free' },
      ],
      activeIntroSlide: 0,
      introAutoplayTimer: null,
      introImages: [
        { src: require('@/assets/content/mod-features.webp'), alt: 'GB WhatsApp mod features' },
        { src: require('@/assets/content/gb-whatsapp-pro-other-features.webp'), alt: 'GB WhatsApp other features' },
        { src: require('@/assets/content/gb-whatsapp-pro-inapp-langauge-change.webp'), alt: 'GB WhatsApp in-app language change' },
        { src: require('@/assets/content/gost-mode-feature.webp'), alt: 'GB WhatsApp ghost mode feature' },
        { src: require('@/assets/content/interface.webp'), alt: 'GB WhatsApp interface' },
        { src: require('@/assets/content/gb-whatsapp-pro-lock-feature.webp'), alt: 'GB WhatsApp app lock feature' },
      ],
      faqs: [
        {
          q: 'Is GB WhatsApp free?',
          a: 'Yes. GB WhatsApp is generally offered as a free APK for Android users.',
        },
        {
          q: 'Is GB WhatsApp on Google Play?',
          a: 'No. GB WhatsApp is a modified third-party app and is not distributed through the Google Play Store.',
        },
        {
          q: 'Can I use two WhatsApp accounts?',
          a: 'Many users use GB WhatsApp alongside another WhatsApp installation, but compatibility depends on the package and device.',
        },
        {
          q: 'Should I back up chats before installing?',
          a: 'Yes. Always back up important chats and media before installing, updating, or switching WhatsApp clients.',
        },
      ],
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
    this.startIntroAutoplay();
  },
  beforeDestroy() {
    this.stopIntroAutoplay();
  },
  methods: {
    setIntroSlide(index) {
      this.activeIntroSlide = index;
      this.restartIntroAutoplay();
    },
    prevIntroSlide() {
      this.activeIntroSlide = (this.activeIntroSlide - 1 + this.introImages.length) % this.introImages.length;
      this.restartIntroAutoplay();
    },
    nextIntroSlide() {
      this.advanceIntroSlide();
      this.restartIntroAutoplay();
    },
    advanceIntroSlide() {
      this.activeIntroSlide = (this.activeIntroSlide + 1) % this.introImages.length;
    },
    startIntroAutoplay() {
      if (typeof window === 'undefined' || this.introImages.length < 2) {
        return;
      }
      this.stopIntroAutoplay();
      this.introAutoplayTimer = window.setInterval(() => {
        this.advanceIntroSlide();
      }, 3500);
    },
    stopIntroAutoplay() {
      if (typeof window === 'undefined' || !this.introAutoplayTimer) {
        return;
      }
      window.clearInterval(this.introAutoplayTimer);
      this.introAutoplayTimer = null;
    },
    restartIntroAutoplay() {
      this.startIntroAutoplay();
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          this.apk = res.code == 200 ? res.data.apk : process.env.VUE_APP_GBLINK;
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {},
  },
};
</script>

<style scoped>
#maincontent.page-main-narrow {
  padding: 1rem 0 3rem;
}
.home-article.prose {
  max-width: none;
  width: 100%;
  margin: 0 auto;
  padding: 0 1.25rem 2rem;
  line-height: 1.65;
  color: #222;
  font-size: 1.05rem;
}
.home-hero-panel {
  background: linear-gradient(165deg, #f2fbf7 0%, #ffffff 45%, #f8fcfa 100%);
  border: 1px solid #d4ebe3;
  border-radius: 8px;
  padding: 1.5rem 1.15rem 1.75rem;
  margin: 0 0 2rem;
  box-shadow: 0 10px 40px rgba(18, 140, 126, 0.09);
}
.home-hero-panel h1 {
  color: #0d6b5f;
  font-size: clamp(1.35rem, 4.2vw, 2.05rem);
  margin: 0.35rem 0 0.5rem;
  line-height: 1.25;
  text-align: center;
  font-weight: 800;
}
.home-hero-icon-wrap {
  display: flex;
  justify-content: center;
  margin: 1rem 0 0.75rem;
}
.home-hero-icon-ring {
  padding: 10px;
  border-radius: 8px;
  background: linear-gradient(145deg, #ffffff, #e8f5f0);
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.18);
}
.home-hero-icon {
  width: min(220px, 48vw);
  height: auto;
  display: block;
  border-radius: 8px;
}
.home-hero-cta-wrap {
  display: flex;
  justify-content: center;
  margin: 0 0 1.25rem;
}
.home-app-details-wrap {
  margin-top: 0.25rem;
  padding-top: 1.1rem;
  border-top: 1px solid rgba(18, 140, 126, 0.2);
}
.home-app-details-heading {
  margin: 0 0 0.85rem;
  font-size: 1.2rem;
  font-weight: 800;
  color: #075e54;
  text-align: center;
}
.home-app-details-table-wrap {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #cde8df;
  background: #fff;
}
.home-app-details-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}
.home-app-details-table th,
.home-app-details-table td {
  padding: 0.65rem 1rem;
  text-align: left;
  border-bottom: 1px solid #e8f2ee;
  vertical-align: top;
}
.home-app-details-table tbody tr:last-child th,
.home-app-details-table tbody tr:last-child td {
  border-bottom: none;
}
.home-app-details-table th {
  width: 38%;
  max-width: 11rem;
  background: #e9f7ef;
  color: #075e54;
  font-weight: 700;
}
.home-download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem 1.85rem;
  background: #128c7e;
  color: #fff !important;
  border-radius: 8px;
  text-decoration: none !important;
  font-weight: 700;
  font-size: 1.05rem;
  box-shadow: 0 3px 12px rgba(18, 140, 126, 0.35);
}
.home-article.prose > h2 {
  color: #075e54;
  font-size: 1.85rem;
  margin: 2.7rem auto 1rem;
  line-height: 1.22;
  text-align: center;
  font-weight: 800;
}
.home-image-carousel {
  position: relative;
  display: grid;
  grid-template-columns: 2.75rem minmax(0, 1fr) 2.75rem;
  align-items: center;
  gap: 0.85rem;
  max-width: 760px;
  margin: 1.35rem auto 2.1rem;
}
.home-carousel-stage {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 360px;
  padding: 0.8rem;
  border: 1px solid #e4eee9;
  border-radius: 8px;
  background: #f8fcfa;
  overflow: hidden;
}
.home-carousel-image,
.home-wide-image {
  display: block;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #e4eee9;
}
.home-carousel-image {
  max-height: 520px;
  border: none;
  border-radius: 6px;
  object-fit: contain;
}
.home-carousel-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border: 1px solid #bfe5d2;
  border-radius: 50%;
  background: #fff;
  color: #075e54;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(18, 140, 126, 0.12);
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}
.home-carousel-arrow span {
  font-size: 2rem;
  line-height: 1;
  transform: translateY(-1px);
}
.home-carousel-arrow:hover,
.home-carousel-arrow:focus-visible {
  background: #128c7e;
  color: #fff;
  transform: translateY(-1px);
}
.home-carousel-dots {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.1rem;
}
.home-carousel-dot {
  width: 0.7rem;
  height: 0.7rem;
  padding: 0;
  border: 1px solid #9fd7bd;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
}
.home-carousel-dot.active {
  background: #128c7e;
  border-color: #128c7e;
}
.home-wide-image {
  max-width: 760px;
  margin: 1rem auto 1.5rem;
}
.home-features-subheading {
  margin: 1.35rem 0 0.5rem;
  font-size: 1.08rem;
  font-weight: 700;
  color: #111;
  line-height: 1.3;
}
.home-article ul,
.home-article ol {
  padding-left: 0;
}
.home-article li {
  margin: 0.42rem 0;
}
.home-article a {
  color: #128c7e;
  font-weight: 600;
}
.home-compare-table-wrap {
  overflow-x: auto;
  margin: 1rem 0 1.25rem;
}
.home-compare-table {
  width: 100%;
  min-width: 860px;
  border-collapse: collapse;
  font-size: 0.9rem;
  line-height: 1.32;
}
.home-compare-table th,
.home-compare-table td {
  border: 1px solid #d8d8d8;
  padding: 0.35rem 0.5rem;
  text-align: left;
  vertical-align: top;
}
.home-compare-table thead th {
  font-weight: 700;
  background: #f9f9f9;
}
.home-faq-item {
  margin-bottom: 1.1rem;
}
.home-faq-q {
  margin: 0 0 0.3rem;
  line-height: 1.45;
  font-weight: 700;
}
.home-faq-a {
  margin: 0;
  line-height: 1.65;
}
@media screen and (max-width: 768px) {
  .home-article.prose > h2 {
    font-size: 1.55rem;
  }
  .home-image-carousel {
    grid-template-columns: 2.35rem minmax(0, 1fr) 2.35rem;
    gap: 0.55rem;
  }
  .home-carousel-stage {
    min-height: 300px;
    padding: 0.55rem;
  }
  .home-carousel-arrow {
    width: 2.35rem;
    height: 2.35rem;
  }
  .home-carousel-arrow span {
    font-size: 1.75rem;
  }
}
@media screen and (max-width: 520px) {
  .home-article.prose > h2 {
    font-size: 1.3rem;
  }
  .home-image-carousel {
    grid-template-columns: 1fr;
    gap: 0.7rem;
  }
  .home-carousel-stage {
    min-height: 240px;
    grid-row: 1;
  }
  .home-carousel-arrow {
    position: absolute;
    top: calc(50% - 1.5rem);
    z-index: 1;
    background: rgba(255, 255, 255, 0.94);
  }
  .home-carousel-arrow-prev {
    left: 0.45rem;
  }
  .home-carousel-arrow-next {
    right: 0.45rem;
  }
  .home-app-details-table th,
  .home-app-details-table td {
    padding: 0.5rem 0.65rem;
    font-size: 0.88rem;
  }
}
</style>
